import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export const Button = ({
  children,
  className = '',
  href,
  ...props
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      e.preventDefault();
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
    props.onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-gold text-charcoal font-bold py-4 px-8 rounded-sm shadow-luxury hover:bg-[#d4b67d] transition-colors duration-300 tracking-wide uppercase text-sm md:text-base ${className}`} {...props} onClick={handleClick} data-id="element-14">
      {children}
    </motion.button>;
};